export default __webpack_public_path__ + "images/ab6b67d06b1911de2d61b8988ffdc51a.png";